import { AppSubdomains } from 'src/types/common';
import { SpecializedStoresConfig } from '../types/routeProtection.types';
import { getSubdomain } from 'src/utils/domain/getSubdomain';

export const specializedStoresConfig: SpecializedStoresConfig = [
  {
    subdomain: AppSubdomains.Terea,
    strategy: 'exclude',
    exceptions: [
      {
        path: '/specialized-stores/welcome',
        props: {
          disableAuthProtection: false,
          includedSubdomains: [AppSubdomains.Terea],
        },
      },
      {
        path: '/specialized-stores/verify',
        props: {
          disableAuthProtection: true,
          includedSubdomains: [AppSubdomains.Terea],
        },
      },
      {
        path: '/specialized-stores/products',
        props: {
          disableAuthProtection: true,
          includedSubdomains: [AppSubdomains.Terea],
        },
      },
      {
        path: '/products/:productSlug/:productId',
        props: {
          disableAuthProtection: true,
          includedSubdomains: [AppSubdomains.Terea],
        },
      },
      {
        path: '/checkout',
        props: {
          includedSubdomains: [AppSubdomains.Terea],
          disableAuthProtection: false,
        },
      },
      {
        path: '/cart',
        props: {
          includedSubdomains: [AppSubdomains.Terea],
          disableAuthProtection: false,
        },
      },
      {
        path: '/payment-verification',
        props: {
          includedSubdomains: [AppSubdomains.Terea],
          disableAuthProtection: false,
        },
      },
    ],
  },
  {
    subdomain: AppSubdomains.Homebar,
    strategy: 'include',
    exceptions: [
      {
        path: '/promociones',
        props: {},
      },
      {
        path: '/wallet',
        props: {},
      },
    ],
  },
];

export const UNAUTHENTICATED_FALLBACKS: Record<AppSubdomains, string> = {
  [AppSubdomains.Pari]: '/login',
  [AppSubdomains.Homebar]: '/login',
  [AppSubdomains.Terea]: '/specialized-stores/welcome',
};

export const AUTHENTICATED_FALLBACKS: Record<AppSubdomains, string> = {
  [AppSubdomains.Pari]: '/',
  [AppSubdomains.Homebar]: '/',
  [AppSubdomains.Terea]: '/specialized-stores/products',
};

interface GetFallbackUrlParams {
  isAuthenticated: boolean;
}

export const getFallbackUrl = ({
  isAuthenticated,
}: GetFallbackUrlParams): string => {
  const subdomain = getSubdomain(AppSubdomains, AppSubdomains.Pari);
  const fallbacks = isAuthenticated
    ? AUTHENTICATED_FALLBACKS
    : UNAUTHENTICATED_FALLBACKS;

  return fallbacks[subdomain];
};
